import React, { FC } from "react"
import { SbBlokData } from "@storyblok/react"
import Image from "next/image"
import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay, Pagination } from "swiper/modules"
import "swiper/css"
import "swiper/css/pagination"

import { BlokImage } from ".."
import StarRating from "../../components/star-rating-v2"
import star from "../../assets/vector/star-brown.svg"
import { readImage } from "../../app/utils/read-image"

type Image = {
  src: string
  alt: string
}

interface Item {
  description: string
  rating: string
  image: BlokImage | Image
  distance: string
  cost: string
}

export interface IItem extends SbBlokData {
  items?: Item[]
  title?: string
  subTitle?: string
  coloredTitle?: string
}
const CardSetItem: FC<Item> = ({
  image,
  description,
  rating,
  distance,
  cost,
}) => {
  return (
    <article className="mb-10 md:mb-1">
      <section className="mx-auto max-w-[354px] md:min-h-[300px] lg:min-h-[300px] max-h-[554px] sm:w-[210px] lg:w-[354px] lg:h-[556px] sm:p-2 lg:p-4 border bg-secondary-100 border-secondary-300 rounded-3xl">
        <div className="">
          <Image
            className="object-cover w-full lg:w-[318px] h-[333px] rounded-lg"
            src={readImage(image)}
            alt={image?.alt || ""}
            width={318}
            height={333}
          />
        </div>

        <div className="mt-7">
          <StarRating
            rating={parseInt(rating)}
            star={{ ...star, width: 16, height: 16 }}
          />
          <div className="sm:text-lg lg:text-2xl mb-2 mt-3 font-merriweather text-secondary-900">
            {description}
          </div>
          <p className={`text-gray14 mb-3 mt-2 text-base font-inter`}>
            {distance} miles
          </p>
          <p className="text-gray14 text-xl lg:text-2xl font-merriweather">
            ${cost}
          </p>
        </div>
      </section>
    </article>
  )
}

const CardSet = ({ blok }: { blok: IItem }) => {
  const { items, title, subTitle, coloredTitle } = blok

  return (
    <section className="max-w-[1334px] mx-auto px-4 pt-8 mt-10 lg:pt-10 lg:mt-8">
      {(title || coloredTitle) && (
        <h2 className="font-merriweather font-normal mb-6 text-3xl leading-[48px] lg:text-[40px] lg:leading-[72px] text-center lg:px-18 mx-auto lg:max-w-[1118px]">
          {title}
          <span className="text-secondary-500"> {coloredTitle}</span>
        </h2>
      )}
      <p className="font-inter mb-8 mx-auto text-center text-2xl">{subTitle}</p>
      <div className="md:flex md:gap-4 lg:gap-x-12 mx-auto justify-center mb-12">
        {items?.map((item) => (
          <CardSetItem
            cost={item.cost}
            distance={item.distance}
            rating={item.rating}
            description={item.description}
            image={item.image}
            key={item.description}
          />
        ))}
      </div>
    </section>
  )
}

export default CardSet
